var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_shared-key.js
// module id = 64
// module chunks = 0